import React, { useEffect } from 'react';
import './styles/base.css';

function App() {
  useEffect(() => {
    const scriptUrls = [
      "/js/gsap.min.js",
      "/js/lenis.min.js",
      "/js/imagesloaded.pkgd.min.js",
      "/js/utils.js",
      "/js/smoothscroll.js",
      "/js/index.js"
    ];

    scriptUrls.forEach(src => {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    });
  }, []);

  return (
    <main>
      
    </main>
  );
}

export default App;
